export const userPlatformSearch = (userList, searchText = "") => {
  if (!searchText || searchText.trim() === "") return userList;
  const searchWordList = searchText?.toLowerCase().split(" ");

  return userList?.filter((user) => {
    const firstName =
      user?.firstName?.toLowerCase() ||
      user?.user?.firstName?.toLowerCase() ||
      "";
    const lastName =
      user?.lastName?.toLowerCase() ||
      user?.user?.lastName?.toLowerCase() ||
      "";
    const teamName =
      user?.team?.name?.toLowerCase() || user?.teamName?.toLowerCase() || "";
    const extendedGroupName = user?.extendedGroupName?.toLowerCase() || "";

    const armyName =
      user?.army?.name?.toLowerCase() ||
      user?.armyName?.toLowerCase() ||
      user?.faction?.name?.toLowerCase() ||
      "";
    const subFactionName = user?.subFaction?.name?.toLowerCase() || "";
    const characterName =
      user?.character?.name?.toLowerCase() ||
      user?.characterName?.toLowerCase() ||
      "";

    let i = 0;
    let result = true;

    while (i < searchWordList?.length && result) {
      if (
        !(
          firstName.includes(searchWordList[i]) ||
          lastName.includes(searchWordList[i]) ||
          extendedGroupName.includes(searchWordList[i]) ||
          teamName.includes(searchWordList[i]) ||
          armyName.includes(searchWordList[i]) ||
          subFactionName.includes(searchWordList[i]) ||
          characterName.includes(searchWordList[i])
        )
      ) {
        result = false;
      }
      i++;
    }

    return result;
  });
};

export const teamPlatformSearch = (teamList, searchText = "") => {
  if (!searchText || searchText.trim() === "") return teamList;
  const searchWordList = searchText.toLowerCase().split(" ");

  return teamList?.filter((team) => {
    const filteredPlayerList = team?.players
      ? userPlatformSearch(team.players, searchText)
      : [];
    if (filteredPlayerList?.length) return true;

    const teamName = team?.name?.toLowerCase() || "";
    const teamCaptainFirstName =
      team?.teamCaptainFirstName?.toLowerCase() ||
      team?.captain?.firstName ||
      "";
    const teamCaptainLastName =
      team?.teamCaptainLastName?.toLowerCase() || team?.captain?.lastName || "";

    let i = 0;
    let result = true;

    while (i < searchWordList?.length && result) {
      if (
        !(
          teamName.includes(searchWordList[i]) ||
          teamCaptainFirstName.includes(searchWordList[i]) ||
          teamCaptainLastName.includes(searchWordList[i])
        )
      ) {
        result = false;
      }
      i++;
    }

    return result;
  });
};

// Add ability to pass in translation function, if not present original English msg will show
export const getSearchProps = (isTeamEvent = false, t = null) => {
  return {
    label: t
      ? isTeamEvent
        ? t("searchTeamOrPlayer")
        : t("searchPlayer")
      : isTeamEvent
        ? "Search for a team or a player"
        : "Search for a player",
    performSearch: isTeamEvent ? teamPlatformSearch : userPlatformSearch
  };
};
